import { useState, useEffect, useCallback } from 'react';
import { useBackClose } from '../utils/backStack';

export function ConfirmModal({ message, onConfirm, onCancel }) {
    useBackClose(true, onCancel);
    useEffect(() => {
        const handle = (e) => {
            if (e.key === 'Enter') onConfirm();
            if (e.key === 'Escape') onCancel();
        };
        window.addEventListener('keydown', handle);
        return () => window.removeEventListener('keydown', handle);
    }, [onConfirm, onCancel]);
    return (
        <div className="confirm-overlay">
            <div className="confirm-box">
                <p className="confirm-msg">{message}</p>
                <div className="confirm-actions">
                    <button className="confirm-cancel" onClick={onCancel}>취소</button>
                    <button className="confirm-ok" onClick={onConfirm}>확인</button>
                </div>
            </div>
        </div>
    );
}

export function useConfirm() {
    const [state, setState] = useState(null);
    const confirm = useCallback((message) => new Promise(resolve => setState({ message, resolve })), []);
    const handleConfirm = useCallback(() => { if (state) { state.resolve(true);  setState(null); } }, [state]);
    const handleCancel  = useCallback(() => { if (state) { state.resolve(false); setState(null); } }, [state]);
    const modal = state
        ? <ConfirmModal message={state.message} onConfirm={handleConfirm} onCancel={handleCancel} />
        : null;
    return { confirm, modal };
}
